import { render, staticRenderFns } from "./FormCreate.vue?vue&type=template&id=5edfe4c0&scoped=true"
import script from "./FormCreate.vue?vue&type=script&lang=js"
export * from "./FormCreate.vue?vue&type=script&lang=js"
import style0 from "./FormCreate.vue?vue&type=style&index=0&id=5edfe4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edfe4c0",
  null
  
)

export default component.exports